export default theme => ({
  buttonDumo: {
    // display: 'inline-block',
    width: '100%',
    display: 'block',
    textTransform: 'none',
    marginBottom: '1rem',
  },
  buttonPopout: {
    width: '100%',
    display: 'block',
    textTransform: 'none',
  },
  dumoHomeContainer: {
    width: '100%',
    height: '100%',
  },
  textFieldDumo: {
    display: 'inline-block',
    // minWidth: 'calc(100% - 75px)',
    width: '100%',
    height: 36,
    marginTop: 3,
    marginRight: 5,
  },
  mapContainer: {
    width: '100%',
    height: '50vh',
  },
})



// WEBPACK FOOTER //
// ./src/components/TaskPrompt/TaskPrompt.styles.js